import styled from 'styled-components'

import { AvatarSize } from 'components/avatar/Avatar'
import CustomFormInput from 'components/input/custom-form-input/CustomFormInput'
import { BUTTONS, FORM, PLACEHOLDERS } from 'locales/locales'
import { useTranslation } from 'react-i18next'
import { requiredValidation } from 'utils/helpers/validations'
import SelectImage from 'components/input/select-input/SelectImage'

interface IGeneralProps {
  avatar: string
  name: string
  description: string
  formChecked: boolean
  onChange: (key: string, value: string) => void
  onSelectGroupAvatar: (fileList: FileList) => void
  loading: boolean
}

const General = ({
  avatar,
  name,
  description,
  formChecked,
  onChange,
  onSelectGroupAvatar,
  loading
}: IGeneralProps) => {
  const { t } = useTranslation()

  const isNameValid = formChecked ? requiredValidation(name, t(FORM.TEAM_NAME)).errorText : ''

  const onChangeTeamName = (value: string) => {
    onChange('name', value)
  }

  const onChangeTeamDescription = (value: string) => {
    onChange('description', value)
  }
  return (
    <Wrapper>
      <SelectImage
        type={'team-avatar'}
        avatar={avatar}
        text={name || 'G'}
        buttonText={BUTTONS.UPLOAD}
        avatarSize={AvatarSize.biggest}
        loading={loading}
        onSelectPhoto={onSelectGroupAvatar}
      />
      <FormWrapper>
        <CustomFormInput
          value={name}
          title={t(FORM.TEAM_NAME) as string}
          placeholder={t(PLACEHOLDERS.TEAM_NAME)}
          onChange={onChangeTeamName}
          errorText={isNameValid}
        />
        <CustomFormInput
          value={description}
          title={t(FORM.TEAM_DESCRIPTION) as string}
          placeholder={t(PLACEHOLDERS.TEAM_DESCRIPTION)}
          optionalTitle={t(FORM.OPTIONAL) as string}
          onChange={onChangeTeamDescription}
        />
      </FormWrapper>
    </Wrapper>
  )
}

export default General

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  column-gap: 20px;
`

const FormWrapper = styled.div`
  width: 100%;
`
